export const API_URL = 'https://linkserv.sensez9.tech/be/';
// development base url
// export const API_URL = 'http://3.80.38.16:8082/';

export const REFRESH_TOKEN_URL = `${API_URL}v1/refresh_token`;
export const AUTH_API = `${API_URL}v1/auth`;
export const GET_COUNTIES_FROM_ZIP_CODES = `${API_URL}v1/getCountiesFromZipCodes`;
export const GET_CITY_BY_ZIP_CODE = `${API_URL}v1/getCityByZipCodeWithToken`;
export const GET_ELIGIBILITY_QUESTION = `${API_URL}v1/getQuestionForPreviewWithOutToken`;
export const GET_SITE_LIST_BY_COUNTY = `${API_URL}v1/getSiteListByCountyWithoutToken`;
export const GET_SITE_LIST_BY_COUNTY_WITH_TAX_TYPES = `${API_URL}v1/getSiteListByClientIdAndCountyForNavigatorsWithToken`;
export const GET_COUNTIES = `${API_URL}v1/getCountiesWithoutToken`;
export const GET_COUNTIES_WITH_TAX_TYPE = `${API_URL}v1/getCountyByRegionIdForNavigatorsWithoutToken`;
export const GET_AVAILABLE_TIMESLOT_BY_SITE_TAXTYPE_DATE = `${API_URL}v1/getAvailableTimeSlotBySiteIdAndTaxtypeAndDateWithoutToken`;
export const GET_AVAILABLE_DATES_FOR_CALENDAR_BY_SERVICE_TYPE = `${API_URL}v1/getAvailableDatesForCalendarByServiceTypeV1WithoutToken`;
export const CREATE_APPOINTMENT = `${API_URL}v1/createAppointmentWithoutToken`;
export const CHECK_EXISTING_APPOINTMENT = `${API_URL}v1/checkExistingAppointmentWithoutToken`;
export const SEARCH_APPOINTMENT = `${API_URL}v1/searchAppointmentWithoutToken`;
export const DELETE_APPOINTMENT = `${API_URL}v1/deleteAppointmentWithoutToken`;
export const GET_CLIENT_DETAILS_FROM_CLIENT_NAME = `${API_URL}v1/getClientDetailsFromClientName`;
export const UPDATE_APPOINTMENT_DETAILS = `${API_URL}v1/updateAppointmentDetailsWithoutToken`;
export const UPDATE_CLIENT_DETAILS = `${API_URL}v1/updateAppointmentClientDetailsWithoutToken`;
export const GET_APPOINTMENT_UPDATE_COUNT = `${API_URL}v1/getAppointmentUpdateCountWithoutToken`;
export const GET_APPOINTMENT_BY_APPOINTMENT_ID = `${API_URL}v1/getAppointmentByAppointmentIdWithoutToken`;
export const GET_COUNTY_BY_CLIENT_ID = `${API_URL}v1/getCountyByClientIdForSelfScheduler`
export const TRANSLATION_API = `${API_URL}v1/getLablesByLanguage`
export const ZIP_CODE_GOOGLE_MAP = `${API_URL}v1/getNearestSiteByRyZipcodesWithoutToken`;
export const SAVE_ELIGIBILITY_BEFORE_APPOINTMENT = `${API_URL}v1/saveEligibilityWithoutToken`;

